<template>
  <img v-bind="$attrs" :src="currentSrc" :alt="alt" />
</template>

<script setup>
import projectDefaultCover from '~/assets/images/project/projectDefaultCover.jpg';

const props = defineProps({
  src: { type: String, required: true },
  alt: { type: String, default: '' },
  fallback: { type: String, default: projectDefaultCover },
});

const currentSrc = ref(props.src);

watch(() => props.src, check);

onMounted(check);

async function validateImage(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url;

    img.onload = async () => {
      try {
        await img.decode();
        resolve(true);
      } catch {
        resolve(false);
      }
    };

    img.onerror = () => resolve(false);
  });
}

async function check() {
  currentSrc.value = props.src;

  const ok = await validateImage(props.src);

  if (!ok) {
    currentSrc.value = props.fallback;
  }
}
</script>
